import api from 'api'

export type CreateIndeedFlexShiftParams = {
  ifClientId: number
  ifShiftId: number
  specificWorkerIds?: number[]
}

export type CreateIndeedFlexShiftResponse = {
  shiftIds: number[]
}

export const createIndeedFlexShift = async (
  params: CreateIndeedFlexShiftParams
): Promise<CreateIndeedFlexShiftResponse> => {
  const result = await api.post<CreateIndeedFlexShiftResponse>(
    '/admin/indeed_flex/shifts/create',
    params
  )
  return result.data
}
